import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { telHref } from "../utils/format";
import SocialIcons from "./SocialIcons";

const linkStyle = { color: "#1D2A4D" };

const Footer = () => {
  const { config } = useSite();
  const { contact: c, footer } = config;

  const contactRows = [
    { icon: "icon-phone", label: c.phoneDisplay, href: telHref(c.phone) },
    { icon: "icon-email", label: c.email, href: `mailto:${c.email}`, small: true },
    { icon: "icon-location", label: c.address, href: config.map.directionsUrl, external: true },
    { icon: "icon-clock", label: config.hoursSummary },
  ];

  return (
    <footer className="footer">
      <div className="footer-primary">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-3">
              <div className="footer-widget-about">
                <img src={config.logo.light} alt={config.name} className="mb-30" />
                <p className="color-gray" style={{ textAlign: "justify" }}>
                  {footer.about}
                </p>
                <Link to="/appointment" className="btn btn__primary btn__primary-style2 btn__link">
                  <span>Make Appointment</span>
                  <i className="icon-arrow-right"></i>
                </Link>
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-2 offset-lg-1">
              <div className="footer-widget-nav">
                <h6 className="footer-widget__title">Quick Links</h6>
                <ul className="list-unstyled">
                  {footer.quickLinks.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to}>{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-2">
              <div className="footer-widget-nav">
                <h6 className="footer-widget__title">Other Links</h6>
                <ul className="list-unstyled">
                  {footer.otherLinks.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to}>{l.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="footer-widget-contact">
                <h6 className="footer-widget__title color-heading">Quick Contacts</h6>
                <ul className="contact-list list-unstyled">
                  <li>If you have any questions or need help, feel free to contact our team.</li>
                </ul>

                <ul className="contact__list list-unstyled mb-30 w-bold">
                  {contactRows.map((row) => (
                    <li key={row.icon} className="d-flex align-items-center gap-2 mb-1" style={linkStyle}>
                      <span style={{ width: "15px" }}>
                        <i className={row.icon} style={row.small ? { fontSize: "12px" } : undefined}></i>
                      </span>
                      {row.href ? (
                        <a
                          className="fw-bold"
                          style={linkStyle}
                          href={row.href}
                          {...(row.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                          {row.label}
                        </a>
                      ) : (
                        <span className="fw-bold">{row.label}</span>
                      )}
                    </li>
                  ))}
                </ul>

                <div className="d-flex align-items-center">
                  <a
                    href={config.map.directionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn__primary btn__link mr-30"
                  >
                    <i className="icon-arrow-right"></i>
                    <span>Get Directions</span>
                  </a>
                  <SocialIcons social={config.social} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 d-flex justify-content-center align-items-center">
              <span className="fz-14 mr-1 text-center">
                Copyright © {footer.copyrightYear} <span style={linkStyle}>{config.name}</span>. Developed By{" "}
                <a href={footer.developer.url} target="_blank" rel="noopener noreferrer" className="fz-14" style={linkStyle}>
                  {footer.developer.name}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
